import { NgModule } from '@angular/core';
import { CaseChartOfAccountsService } from './case-chart-of-accounts.service';

@NgModule({
  providers: [CaseChartOfAccountsService],
})
export class CaseChartOfAccountsRoutingModule {}
